<template>
  <div class="app-container store-page">

    <div class="filter-container">
      <div class="filter-title">
        筛选服务人员账号
      </div>
      <div class="filter-form-container">
        <el-input
          v-model="listQuery.account"
          clearable
          placeholder="请输入账号"
          class="filter-item filter-form-item title-input"
          @keyup.enter.native="handleFilter"
        />
        <el-select
          v-model="listQuery.status"
          clearable
          placeholder="请选择状态"
          class="filter-item filter-form-item status-select"
          @change="handleFilter"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>

        <el-select
          v-model="listQuery.store_id"
          clearable
          filterable
          placeholder="请选择门店"
          class="filter-item filter-form-item status-select"
          @change="handleFilter"
        >
          <el-option
            v-for="item in storeList"
            :key="item.id"
            :label="item.store_name"
            :value="item.id"
          />

        </el-select>
        <el-button v-waves class="filter-item" type="default" @click="handleFilter">
          搜索
        </el-button>
        <el-button v-waves class="filter-item" type="default" @click="handleFilter($event,true)">
          重置
        </el-button>

        <el-button
          v-if="0"
          class="filter-item add-btn"
          style="margin-left: 10px;"
          type="primary"
          icon="el-icon-edit"
          @click="showCreate = true"
        >
          新增账号
        </el-button>

      </div>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="账号ID" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="账号">
        <template slot-scope="scope">
          <span>{{ scope.row.account }} </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="所属门店">
        <template slot-scope="scope">
          <span>{{ scope.row.store ? scope.row.store.store_name : '-' }} </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="使用者昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.real_name || '-' }} </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="最近操作时间">
        <template slot-scope="scope">
          <span>{{ (scope.row.updated_at || new Date()) | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="最近操作账号">
        <template slot-scope="scope">
          <span>{{ scope.row.operate_user ? scope.row.operate_user.account : '' }}</span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" width="160">
        <template slot-scope="{row}">
          <span :class="row.status ? 'success-text' : 'danger-text'">已{{ row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="200" v-if="0">
        <template slot-scope="{row}">
          <div class="table-btn-container">
            <el-button
              type="text"
              size="small"
              @click="showManage = true; accountInfo = row"
            >
              编辑
            </el-button>

            <el-button
              type="text"
              size="small"
              @click="onShowEditPassword(row)"
            >
              重置密码
            </el-button>

            <el-popconfirm
              class="table-btn"
              :title="row.status | confirmTitle"
              @onConfirm="updateStatus(row)"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
              >
                {{ (row.status ? 0 : 1) | statusFilter }}
              </el-button>
            </el-popconfirm>
          </div>

        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <edit-password-dialog :show.sync="showEditPassword" :account-info="accountInfo" />

    <add-account :show.sync="showCreate" @update="getList" />

    <manage-account :show.sync="showManage" :account-info="accountInfo" />
  </div>
</template>

<script>
import _ from 'lodash'
import { getToken } from '@/utils/auth'
import { fetchStoreList } from '@/api/store'
import { fetchStoreAccountList as fetchAccountList, updateStoreAccount as updateAccount } from '@/api/storeAccount'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import EditPasswordDialog from '@/components/ManageAccount/designer/editPassword'
import AddAccount from '@/components/addDesignAccount'
import ManageAccount from '@/components/ManageAccount/designer'
import { ROLE_SERVER_ACCOUNT } from '@/constances/role'
const statusMap = {
  1: '启用',
  0: '禁用'
}

const initialQuery = {
  account: '',
  page: 1,
  limit: 20,
  role_id: ROLE_SERVER_ACCOUNT,
  brand_id: undefined,
  store_id: null,
  status: undefined
}

export default {
  name: 'ShopList',
  components: {
    Pagination,
    EditPasswordDialog,
    AddAccount,
    ManageAccount
  },
  directives: { waves },
  filters: {
    statusFilter(status) {
      return statusMap[status]
    },
    confirmTitle(status) {
      const text = `确认${statusMap[status ? 0 : 1]}该账号？`
      return text
    },
    parseUsername(user) {
      const username = _.get(user, ['username'])
      return username || '-'
    },
    filterAddress(data) {
      return _.get(data, ['provinces', 'region_name']) + _.get(data, ['citys', 'region_name']) + _.get(data, ['areas', 'region_name']) + data.address
    }

  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        ...initialQuery
      },
      storeList: [], // 品牌列表
      statusOptions: [],
      showEditPassword: false,
      accountInfo: null,
      showCreate: false,
      showManage: false
    }
  },
  created() {
    if (this.$route.query.showDialog) {
      this.showCreate = true
    }
    // 初始化筛状态
    this.statusOptions = Object.keys(statusMap).map(key => ({ key, label: statusMap[key] }))
    this.getList()
    this.fetchStoreList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      fetchAccountList(this.listQuery).then(response => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    // 列表查询
    handleFilter($event, isClear) {
      this.listQuery.page = 1
      console.log(isClear)
      if (isClear) {
        this.listQuery = {
          ...initialQuery
        }
      }
      this.getList()
    },
    // 编辑状态
    async updateStatus(row) {
      console.log(row)

      const payload = {
        token: getToken(),
        id: row.id,
        status: row.status ? 0 : 1,
        real_name: row.real_name,
        store_id: row.store_id
      }
      this.updateReq(payload, row)
    },
    // update请求
    async updateReq(payload, row) {
      const index = this.list.findIndex(v => v.id === row.id)
      this.listLoading = true
      try {
        const res = await updateAccount(payload.id, {
          ...payload
        })
        this.listLoading = false
        this.list.splice(index, 1, {
          ...row,
          ...res.data
        })
        this.$notify({
          title: '操作成功',
          message: '编辑成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (e) {
        this.listLoading = false
        console.log(e)
      }
    },
    async fetchStoreList() {
      try {
        const res = await fetchStoreList({
          limit: 50
        })
        this.storeList = _.get(res, ['data', 'data']) || []
      } catch (e) {
        console.log(e)
      }
    },

    // 修改密码
    onShowEditPassword(info) {
      this.showEditPassword = true
      this.accountInfo = info
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form-table.scss';
 .store-page ::v-deep .el-form-item__content{
  margin-left: 130px !important;
}

.store-img {
  width: 28px;
  height: 28px;
  &:not(:last-child) {
    margin-right: 10px;
  }
}

.table-btn-container {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .table-btn:not(:last-child) {
    margin-right: 0;
  }
}

</style>
